<template>
  <div>
    <div class="d-flex justify-space-between align-center">
      <div class="d-flex align-center">
        <img
          :src="
            ($vuetify.theme.dark
              ? currentProject.logoSmallDark
              : currentProject.logoSmall) || currentProject.logoSmall
          "
          height="36"
          width="36"
        />
        <div class="heading-4 ml-6 text-uppercase font-weight-medium">
          {{ currentProject.staking.token }}
        </div>
        <div class="text-2 ml-6 font-weight-light gray--text d-none d-sm-block">
          {{ currentProject.text }}
        </div>
        <v-divider vertical class="mx-6 info-divider border-stake d-none d-md-flex"></v-divider>
        <div v-if="!currentProject.variesApy" class="heading-4 d-none d-md-block">
          <span class="font-weight-medium"
            >{{
              (apyMap[currentProject.name] &&
                apyMap[currentProject.name].apy * 100)
                | numberFormat("0,0.00", false)
            }}%</span
          >
          <span class="gray--text ml-1 font-weight-light">APY</span>
        </div>
        <div v-else><span class="font-weight-medium">Varies</span><span class="gray--text ml-1 font-weight-light">APY</span></div>
        <v-divider vertical class="mx-6 border-vaults info-divider d-none d-sm-flex"></v-divider>
        <div
          class="text-7 font-weight-medium px-2 py-1 rounded-5 black--text-abs bg-stake d-none d-sm-block"
        >
          PROOF-OF-STAKE
        </div>
        <v-divider vertical class="mx-6 info-divider border-stake d-none d-sm-flex"></v-divider>
        <div class="d-none d-sm-flex">
          <img :src="market.logo" alt="" height="20" width="20" />
        </div>
      </div>
      <div
        class="text-6 line-height-25 gray--text clickable"
        @click="chartExpanded = !chartExpanded"
      >
        <div v-if="chartExpanded" class="d-flex align-center">
          <span>Collapse Chart</span>
          <v-icon color="gray--text" small>mdi-chevron-up</v-icon>
        </div>
        <div v-else class="d-flex align-center">
          <span>Expand Chart</span>
          <v-icon color="gray--text" small>mdi-chevron-down</v-icon>
        </div>
      </div>
    </div>
    <overview-performance
      class="mt-6"
      :chartType="chartType"
      :chartData="chartData"
    />
    <v-expand-transition>
      <performance-chart
        v-show="chartExpanded"
        @setChartType="v => (chartType = v)"
        @setChartData="v => (chartData = v)"
      />
    </v-expand-transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { projectMapEco } from "@/common/config/ecosystems";
import OverviewPerformance from "../OverviewPerformance";
import PerformanceChart from "../PerformanceChart";

export default {
  components: {
    OverviewPerformance,
    PerformanceChart,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      apyMap: "productStats/stakeApyMap",
    }),
    market() {
      return projectMapEco[this.currentProject.projectName];
    },
  },
  data: () => ({
    chartExpanded: true,
    chartType: "aum",
    chartData: [],
  }),
};
</script>

.<style lang="scss" scoped>
.info-divider {
  height: 20px;
  align-self: center;
}
</style>
